// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/modern/" + {"88":"content-list-filter","141":"contacts-page","321":"content-list","353":"imask","459":"about-page","671":"card-detail-page","858":"catalog-page"}[chunkId] + "." + {"88":"53c71857","141":"ac90f6f1","321":"33064481","353":"26d8b85a","459":"04583acc","671":"2c60cf7d","858":"a2eaa4b4"}[chunkId] + ".js";
};